import { api } from "@/lib/api/api";

export type UploadModule = "material" | "recipe" | "user" | "company" | "organization";

export interface UploadImageResponse {
  module: UploadModule;
  bucket: string;
  key: string;
  fileName: string;
  imageUrl: string;
  thumbnailKey: string;
  thumbnailFileName: string;
  thumbnailUrl: string;
  contentType: string;
  width: number;
  height: number;
  thumbnailWidth: number;
  thumbnailHeight: number;
}

export interface UploadImageMetadata {
  originalFileName?: string;
  processedFileName?: string;
  originalSizeBytes?: number;
  processedSizeBytes?: number;
  originalWidth?: number;
  originalHeight?: number;
  processedWidth?: number;
  processedHeight?: number;
}

async function uploadImage(
  module: UploadModule,
  file: File,
  metadata?: UploadImageMetadata,
): Promise<UploadImageResponse> {
  const formData = new FormData();
  formData.append("file", file);
  if (metadata) {
    Object.entries(metadata).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, String(value));
      }
    });
  }

  return api.request<UploadImageResponse>(`/uploads/${module}/image`, {
    method: "POST",
    body: formData,
    queueOffline: false,
  });
}

export const uploadApi = {
  uploadImage,
};
